import { Point } from './point.model';


/**
 * Cluster abstraction, aggregates map 2D points
 */
export class Cluster extends Point {

    /**
     * Cluster id
     */
    public clusterId?: number;

    /**
     * Points in cluster
     */
    public points: Point[] = [];

    /**
     * Number of points in cluster
     */
    public get pointCount() {
        return this.points.length;
    }


    /**
     * Get cluster unique number
     */
    getClusterPK(): number {
        if (this.clusterId) {
            return this.clusterId;
        }
        if (this.properties && this.properties && this.properties.Id) {
            return - this.properties.Id;
        }
        return -1;
    }

}
